if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      formId = '';
      lastAtcSubmitter= null;
      ctaSubmitButton= null;
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (this.variantIdInput?.disabled) {
          this.variantIdInput.disabled = false;
        }
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.cartItems = document.querySelector('cart-drawer-items');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.ctaSubmitButton = document.getElementById(`${this.submitButton.id}-cta`);
        const remember = (e) => {
          this.lastAtcSubmitter = e.currentTarget ?? null;
        };
        [this.submitButton, this.ctaSubmitButton]
        .filter(Boolean)
        .forEach((btn) => {
          btn?.addEventListener('pointerdown', remember, { capture: true });
          btn?.addEventListener('click', remember, { capture: true });
        });
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
        this.hideErrors = this.dataset.hideErrors === 'true';
        this.formId = this.form.getAttribute('id');
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        const atcSubmitter = this.resolveAtcSubmitter(evt);

        this.handleErrorMessage();
        this.setButtonLoadingState(true);
        this.coolShippingAdded = false;

        let formData = new FormData(this.form);

        if (this.dataset.bundleData) {
          const initialMultiIds = Array.from(formData.entries()).filter(([key]) => key.includes('[id]')).map(([, value]) => value);
          const isMultiForm = this.dataset.multiAdd === 'true';

          let multiItemsLeft = initialMultiIds.length > 0;

          const bundleIndex = initialMultiIds.findIndex((id) => id === this.dataset.bundleProduct);

          if (isMultiForm && bundleIndex !== -1) {
            const cleaned = new FormData();
            multiItemsLeft = false;
            for (const [key, value] of formData.entries().filter(([key]) => key.includes('[id]'))) {
              if (!key.includes(`items[${bundleIndex}]`)) {
                multiItemsLeft = true;
                cleaned.append(key, value);
              }
            }
            formData = cleaned;
            await this.addBundleProduct(atcSubmitter, multiItemsLeft);
          } else if (!isMultiForm)   {
            await this.addBundleProduct(atcSubmitter);
          }
          if (!isMultiForm || !multiItemsLeft) {
            return;
          }
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const maxQuantity = parseInt(formData.get('max-quantity'), 10);
        const requestedQuantity = parseInt(formData.get('quantity'), 10);

        if (maxQuantity > 0 && requestedQuantity > maxQuantity) {
          formData.set('quantity', maxQuantity);
        }

        this.normalizeFormData(formData);

        if (this.cart) {
          formData.append(
            'sections',
            this.cartItems.getSectionsToRender().map(section => section.id).join(',')
          );

          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        if (this.dataset.coolShipping) {
          const appended = await this.appendCoolShippingItem(formData);

          // Ohne den Warenkorb-Stand laesst sich die Kuehlversand-Zeile nicht
          // sicher ergaenzen - der Add wird abgebrochen, statt ein Kuehlprodukt
          // ungekuehlt zu versenden. this.error bleibt bewusst unberuehrt, damit
          // der Button wieder klickbar wird und der Nutzer es erneut versuchen kann.
          if (!appended) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: null,
              message: window.cartStrings?.error,
            });
            this.handleErrorMessage(window.cartStrings?.error);
            this.setButtonLoadingState(false);
            return;
          }
        }

        let obj = Object.fromEntries(config.body.entries());

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then(async (response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');

            if (!this.error) {
              publish(PUB_SUB_EVENTS.addToCartSuccess, {
                source: 'product-form',
                formId: this.formId,
                formData: this.formDataWithoutCoolShipping(formData),
                cartData: response,
                submitter: atcSubmitter,
                atcSubmitter
              });

              let cartDataForPublish = response;
              try {
                cartDataForPublish = await window.depositSync(response);
              } catch (err) {
                console.error('[ProductForm] Error in depositSync:', err);
              }

              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: cartDataForPublish,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            }
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              const unsubscribe = subscribe(PUB_SUB_EVENTS.atcAnimationComplete, () => {
                quickAddModal.hide(true);
                unsubscribe();
              });
            }
            // Handle mix-and-match modal
            const mixMatchModal = this.closest('modal-dialog[data-form-id^="mix-match-form-"]');
            if (mixMatchModal) {
              const unsubscribe = subscribe(PUB_SUB_EVENTS.atcAnimationComplete, () => {
                mixMatchModal.hide(true);
                unsubscribe();
              });
            } 
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            this.setButtonLoadingState(false);
            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      normalizeFormData(fd) {
        // 1. Top-Level quantity abfangen (falls vorhanden)
        let globalQuantity = 1;
        if (fd.has("quantity")) {
          globalQuantity = parseInt(fd.get("quantity"), 10) || 1;
          fd.delete("quantity");
        }

        // 2. Alle Hauptprodukte sammeln
        const productQuantities = {};
        const productUnits = {};

        for (const [key, value] of fd.entries()) {
          const match = key.match(/^items\[(\d+)\]\[id\]$/);
          if (match) {
            const index = match[1];
            const id = value;
            const qKey = `items[${index}][quantity]`;
            const uKey = `items[${index}][properties][_units_per_item]`;

            // Quantity setzen, wenn fehlt
            if (!fd.has(qKey)) {
              fd.set(qKey, String(globalQuantity));
            }

            productQuantities[id] = parseInt(fd.get(qKey), 10) || 1;
            productUnits[id] = parseInt(fd.get(uKey) || "0", 10);
          }
        }

        // 3. Pfand-Einträge anpassen
        for (const [key, value] of fd.entries()) {
          if (key.endsWith("[parent_id]")) {
            const index = key.match(/^items\[(\d+)\]/)[1];
            const parentId = value;

            const parentQty = productQuantities[parentId] || 0;
            const unitsPerItem = productUnits[parentId] || 0;

            const depositQty = parentQty * unitsPerItem;

            fd.set(`items[${index}][quantity]`, String(depositQty));
          }
        }
        
        //4. Top-Level Selling Plan abfangen (falls vorhanden)
        if (fd.has("selling_plan")) {
          const sellingPlan = fd.get('selling_plan');
          fd.set(`items[0][selling_plan]`, sellingPlan);
          fd.delete('selling_plan');
        }

        return fd;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if(this.submitButton?.dataset.icon != "true" ){
            if (text) this.submitButtonText.textContent = text;
          }
        } else {
          this.submitButton.removeAttribute('disabled');
          if(this.submitButton?.dataset.icon != "true" ){
            this.submitButtonText.textContent = window.variantStrings.addToCart;
          }
        }
      }

      setButtonLoadingState(loading = true) {
        const ctaSubmitButton = document.getElementById(`${this.submitButton.id}-cta`);
        if (loading) {
          if (ctaSubmitButton) {
            ctaSubmitButton.setAttribute('aria-disabled', true);
            ctaSubmitButton.classList.add('loading');
            ctaSubmitButton.querySelector('.loading__spinner').classList.remove('hidden');
          }

          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');

          this.querySelector('.loading__spinner').classList.remove('hidden');
        } else {
          this.submitButton.classList.remove('loading');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          if (ctaSubmitButton) {
            ctaSubmitButton.classList.remove('loading');
            if (!this.error) ctaSubmitButton.removeAttribute('aria-disabled');
          }
          this.querySelector('.loading__spinner').classList.add('hidden');
          if (ctaSubmitButton) {
            ctaSubmitButton.querySelector('.loading__spinner').classList.add('hidden');
          }
        }
      }

      async addBundleProduct(atcSubmitter, silent = false) {
        const bundleStore = Alpine.store('bundleStore');
        const response = bundleStore.addBundle(this.dataset.bundleProduct, this.dataset.bundleData)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: this.dataset.bundleProduct,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
           
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');

            let bundleData = null;
            const el = document.querySelector(`.product-item-datalayer`);

            if (el) {
              bundleData = el.textContent;
              bundleData = JSON.parse(bundleData);
            };

            const ev = silent ? PUB_SUB_EVENTS.addToCartSuccessSilent : PUB_SUB_EVENTS.addToCartSuccess;
            publish(ev, {
              formId: this.formId,
              source: 'bundle-add',
              requestItems: [{
                id: bundleData.item_variant_id,
                quantity: 1
              }],
              cartData: response,
              submitter: {
                dataset: {
                  method: 'bundle'
                }
              },
              atcSubmitter: atcSubmitter
            });

            if (silent) {
              return
            }
         
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: bundleData.item_variant_id,
              cartData: {sections: response.sections},
            })

            this.setButtonLoadingState(false);
        });

        return response;
      }

      // Haengt die Kuehlversand-Zeile an dieselbe Add-Request an, statt sie vorab
      // separat hinzuzufuegen. Schlaegt das Produkt fehl, entsteht so auch keine
      // Kuehlversand-Zeile ohne zugehoeriges Produkt - cart/add.js verarbeitet
      // items[] als Ganzes.
      //
      // cart/add.js legt die Zeilen in umgekehrter Reihenfolge des items[]-Arrays
      // an (jede Zeile wird vorn eingefuegt, auf der Stage verifiziert). Die
      // Kuehlversand-Zeile bekommt deshalb Index 0 und alle vorhandenen Zeilen
      // ruecken eins hoch, damit sie im Warenkorb hinter dem Produkt landet.
      //
      // Achtung: das ist beobachtetes Verhalten, keine dokumentierte Zusage von
      // Shopify (MNR-782). Steht die Kuehlversand-Zeile im Warenkorb ploetzlich vor
      // dem Produkt, hat sich diese Reihenfolge geaendert - dann die Sortierung beim
      // Rendern des Cart-Drawers erzwingen statt sie ueber die Payload-Position zu
      // steuern. formDataWithoutCoolShipping haengt nicht daran, das filtert ueber
      // die Varianten-ID.
      async appendCoolShippingItem(fd) {
        const coolShippingId = this.dataset.coolShipping;

        // Der Warenkorb-Stand entscheidet, ob die Zeile schon existiert. Faellt der
        // Request aus (offline, 5xx, HTML-Fehlerseite), ist die Frage nicht zu
        // beantworten: ohne die Zeile ginge ein Kuehlprodukt ungekuehlt raus, mit ihr
        // eine zweite Kuehlgebuehr. Der Aufrufer bricht den Add dann ab.
        let cartData;

        try {
          const response = await fetch(`${routes.cart_url}.js`);
          if (!response.ok) throw new Error(`${routes.cart_url}.js responded ${response.status}`);
          cartData = await response.json();
        } catch (error) {
          console.error('[product-form] cool shipping: cart read failed', error);
          return false;
        }

        // Liegt die Zeile schon im Warenkorb, wird sie nicht ein zweites Mal angelegt.
        if (cartData.items.some(item => String(item.id) === coolShippingId)) return true;

        const idKey = /^items\[(\d+)\]\[id\]$/;

        // Gleiches gilt, wenn die Payload die Kuehlversand-Variante schon selbst
        // enthaelt - beim Multi-Add-Formular der Recommendations ist die Item-Liste
        // nicht fest, sondern haengt an der Auswahl.
        const payloadIds = [...fd.entries()].filter(([key]) => idKey.test(key)).map(([, value]) => value);
        if (payloadIds.includes(coolShippingId) || fd.get('id') === coolShippingId) return true;

        const itemKey = /^items\[(\d+)\](.*)$/;
        const entries = [...fd.entries()].filter(([key]) => itemKey.test(key));

        for (const [key] of entries) {
          fd.delete(key);
        }

        fd.append('items[0][id]', coolShippingId);
        fd.append('items[0][quantity]', '1');
        fd.append('items[0][properties][_coolShipping]', 'true');
        this.coolShippingAdded = true;

        // Die Pfand-Zeilen referenzieren ihr Hauptprodukt ueber parent_id, nicht
        // ueber den Index - das Verschieben laesst normalizeFormData unberuehrt.
        for (const [key, value] of entries) {
          const [, index, rest] = key.match(itemKey);
          fd.append(`items[${Number(index) + 1}]${rest}`, value);
        }

        return true;
      }

      // Die Kuehlversand-Zeile ist eine Versandgebuehr, kein gekauftes Produkt.
      // tracking.js liest die Items aus der formData des addToCartSuccess-Events;
      // bliebe die Zeile darin, zaehlte sie als zusaetzliches add_to_cart-Item
      // mit eigenem GA4-Value und Klaviyo-Event.
      formDataWithoutCoolShipping(fd) {
        if (!this.coolShippingAdded) return fd;

        const entries = [...fd.entries()];

        // Ueber die Varianten-ID statt ueber den Index gesucht: der Filter bleibt
        // damit richtig, falls die Zeile spaeter nicht mehr auf items[0] liegt.
        const coolShippingKey = entries.find(
          ([key, value]) => /^items\[\d+\]\[id\]$/.test(key) && value === this.dataset.coolShipping
        )?.[0];

        if (!coolShippingKey) return fd;

        // "items[3][id]" -> "items[3]", inklusive Klammer, damit items[30] nicht mitgeht.
        const prefix = coolShippingKey.slice(0, coolShippingKey.indexOf(']') + 1);
        const tracked = new FormData();

        for (const [key, value] of entries) {
          if (!key.startsWith(prefix)) tracked.append(key, value);
        }

        return tracked;
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

      async waitForVariationId(){
        const start = Date.now();

        return new Promise((resolve) => {
          const tick = () => {
            const exps = window?.Kameleoon?.API?.Experiments?.getAll?.();
            if (Array.isArray(exps)) {
              const exp = exps.find((e) => typeof e?.name === 'string' && /MORE-9/i.test(e.name));
              if (exp) {
                const varId = String(exp?.associatedVariation?.id);

                if (varId) {
                  return resolve(varId);
                }
              }
            }

            if (Date.now() - start >= 800) {
              return resolve(null);
            }
            requestAnimationFrame(tick);
          };
          tick();
        });
      }
      resolveAtcSubmitter(evt) {
        const native = evt.submitter;
        if (native?.isConnected) return native;

        if (this.lastAtcSubmitter?.isConnected) return this.lastAtcSubmitter;

        const active = document.activeElement;
        if (active?.isConnected) return active;

        return this.submitButton ?? null;
      }
    }
  );
}
